import { useInfiniteQuery } from "react-query";
import { fetchServer } from "../utils";
import { PopularItem } from "./type";
import { LorasType } from "@features/loras/type";

export const usePopularImages = (
  type: PopularItem["type"],
  search: string = ""
) => {
  const pageSize = 10;
  return useInfiniteQuery(
    ["popular-items", type, search],
    async ({ pageParam = 0 }) => {
      const res = await fetchServer<PopularItem[]>(
        `/api/popular/${type}?search=${search}&offset=${pageParam}&limit=${pageSize}`
      );
      return res;
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        return lastPage.length < pageSize
          ? undefined
          : allPages.length * pageSize;
      },
    }
  );
};

export const usePopularLoras = (
  type: PopularItem["type"],
  search: string = ""
) => {
  const pageSize = 50;
  return useInfiniteQuery(
    ["popular-items", type, search],
    async ({ pageParam = 0 }) => {
      const res = await fetchServer<
        (LorasType & { popular_item: PopularItem })[]
      >(
        `/api/popular/${type}?search=${search}&offset=${pageParam}&limit=${pageSize}`
      );
      return res;
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        return lastPage.length < pageSize
          ? undefined
          : allPages.length * pageSize;
      },
    }
  );
};
